module.exports = __webpack_public_path__ + "img/5running3-green.8850883c.png";